import update from 'immutability-helper';
import * as _ from 'lodash';
import {StoreState} from '../../../../App/initialStore';
import {makeActionCreator} from '../../../../crazyEditor/redux/helpers';
import {
  FIELD_NAMES,
  DEFAULT_CURRENCIES,
  isItemSpecificsFieldName,
  isVariationFieldName,
} from '../../../Listings/EbayListing/consts';
import {getAllVariationsDeleted, isFieldEqual} from '../../../Listings/EbayListing/ebayListingSelectors';
const UPDATE_LISTING_DATA = 'ebayListing/UPDATE_LISTING_DATA';
const UPDATE_CATEGORY_SITE_DATA = 'ebayListing/UPDATE_CATEGORY_SITE_DATA';
const UPDATE_SELLER_POLICIES = 'ebayListing/UPDATE_SELLER_POLICIES';
const UPDATE_FIELD_TO_REVISE = 'ebayListing/UPDATE_FIELD_TO_REVISE';
const UPDATE_MULTIPLE_FIELDS_TO_REVISE = 'ebayListing/UPDATE_MULTIPLE_FIELDS_TO_REVISE';
const UPDATE_FIELD_TO_DELETE = 'ebayListing/UPDATE_FIELD_TO_DELETE';
const RESET_FIELDS_TO_REVISE = 'ebayListing/RESET_FIELDS_TO_REVISE';
const UPDATE_RECENTLY_USED_CATEGORIES = 'ebayListing/UPDATE_RECENTLY_USED_CATEGORIES';
const SET_SAVE_AND_UPDATE_CLICKED = 'ebayListing/SET_SAVE_AND_UPDATE_CLICKED';
const CLEAR_STORE = 'ebayListing/CLEAR_STORE';
const SET_OPEN_SECTION_INDEX = 'ebayListing/SET_OPEN_SECTION_INDEX';
const UPDATE_BLURRED_FIELD = 'ebayListing/UPDATE_BLURRED_FIELD';
const UPDATE_SNACKBAR_PROPS = 'ebayListing/UPDATE_SNACKBAR_PROPS';
const SET_PRODUCT_DATA = 'ebayListing/SET_PRODUCT_DATA';
const SET_OPEN_CATEGORY_SELECTOR = 'ebayListing/SET_OPEN_CATEGORY_SELECTOR';
import {createStandardAction} from 'typesafe-actions';
import {isDraftItemId} from '../../../../shared/helpers/EbayListingsGeneralHelpers';

interface updateMultipleFieldsToReviseAction {
  fieldNames: string | string[];
  fieldValue: any;
  fieldProps?: any; // Optional for primitive field type
  originalValue?: any;
}

function removeFieldsToRevise(state: StoreState['ebayListing'], fieldsToRemove: string | string[]) {
  return update(state, {fieldsToRevise: {$apply: fieldsToRevise => _.omit(fieldsToRevise, fieldsToRemove)}});
}

const updateFieldToReviseFunc = (state: StoreState['ebayListing'], action) => {
  if (!state.fieldsToRevise) {
    state = {...state, fieldsToRevise: {}};
  }
  let {fieldNames} = action;
  const {fieldValue, originalValue, fieldProps} = action;
  let fieldValues;
  let originalValues;
  if (_.isArray(fieldNames)) {
    if (_.isPlainObject(fieldValue)) {
      // multi value
      originalValues = originalValue || {};
      fieldValues = fieldValue || {};
    } else {
      // multi field, single values
      fieldValues = _.mapValues(_.mapKeys(fieldNames), () => fieldValue) || {};
      originalValues = _.mapValues(_.mapKeys(fieldNames), () => originalValue) || {};
    }
  } else {
    // single field, single value
    fieldValues = {[fieldNames]: fieldValue};
    originalValues = {[fieldNames]: originalValue};
    fieldNames = [fieldNames];
  }
  let firstValueEqual;
  return _.reduce(
    fieldNames,
    (state, fieldName) => {
      const fieldValue = fieldValues[fieldName];
      const originalValue = originalValues[fieldName];
      if (!_.isUndefined(fieldValue)) {
        const {fieldsToDelete} = state;
        state = update(state, {
          fieldsToDelete: {$set: _.omit(fieldsToDelete, fieldName)},
        });
      }
      if (
        fieldName === FIELD_NAMES.PRIMARY_CATEGORY ||
        fieldName === FIELD_NAMES.EBAY_SITE ||
        (fieldName === FIELD_NAMES.EPID && fieldValue)
      ) {
        // when changing these, get rid of the old itemSpecifics from fieldsToRevise
        const itemID = _.get(state, 'listingData.clData.itemID');
        const isDraft = _.isEmpty(itemID) || isDraftItemId(itemID);
        const variationsToDelete = getAllVariationsDeleted(_.get(state, 'listingData'));
        state = update(state, {
          fieldsToRevise: {
            $set: {
              ..._.omitBy(
                state.fieldsToRevise,
                (fieldValue, fieldName) =>
                  isItemSpecificsFieldName(fieldName) || (isDraft && isVariationFieldName(fieldName))
              ),
              ...(isDraft &&
                !_.isEmpty(variationsToDelete) && {
                  [FIELD_NAMES.VARIATIONS]: variationsToDelete,
                }),
            },
          },
        });
      }
      if (fieldName === FIELD_NAMES.EBAY_SITE) {
        state = update(state, {
          fieldsToRevise: {
            [FIELD_NAMES.CURRENCY]: {$set: DEFAULT_CURRENCIES[fieldValue]},
            [FIELD_NAMES.PRIMARY_CATEGORY]: {$set: null},
            [FIELD_NAMES.PAYMENT_POLICY]: {$set: null},
            [FIELD_NAMES.SHIPPING_POLICY]: {$set: null},
            [FIELD_NAMES.RETURN_POLICY]: {$set: null},
            [FIELD_NAMES.PACKAGE_TYPE]: {$set: null},
            [FIELD_NAMES.EPID]: {$set: null},
          },
        });
        state = removeFieldsToRevise(state, [
          FIELD_NAMES.PRIMARY_CATEGORY,
          FIELD_NAMES.PAYMENT_POLICY,
          FIELD_NAMES.SHIPPING_POLICY,
          FIELD_NAMES.PACKAGE_TYPE,
          FIELD_NAMES.EPID,
        ]);
      }
      if (fieldName === FIELD_NAMES.LISTING_TYPE) {
        state = update(state, {
          fieldsToRevise: {
            [FIELD_NAMES.BUY_IT_NOW_PRICE]: {$set: 0},
            [FIELD_NAMES.RESERVE_PRICE]: {$set: 0},
          },
        });
        state = removeFieldsToRevise(state, FIELD_NAMES.DURATION);
      }
      if (fieldName === FIELD_NAMES.EBAY_TITLE) {
        const {fieldsToRevise, listingData} = state;
        if (_.isEmpty(_.get(listingData, FIELD_NAMES.TITLE)) && _.isEmpty(fieldsToRevise[FIELD_NAMES.TITLE])) {
          state = update(state, {
            fieldsToRevise: {
              [FIELD_NAMES.TITLE]: {$set: fieldValue},
            },
          });
        }
      }
      if (firstValueEqual || isFieldEqual(originalValue, fieldValue, fieldProps) || (!originalValue && !fieldValue)) {
        firstValueEqual = firstValueEqual === undefined;
        return removeFieldsToRevise(state, fieldName);
      }
      return update(state, {
        fieldsToRevise: {[fieldName]: {$set: fieldValue}},
      });
    },
    state
  );
};

export default function reducer(state: any = {}, action: any = {}) {
  let {fieldsToDelete} = state;
  switch (action.type) {
    case CLEAR_STORE:
      return {
        fieldsToRevise: {},
        fieldsToDelete: {},
        blurredFields: {},
        productData: {},
      };
    case SET_SAVE_AND_UPDATE_CLICKED:
      const {saveAndUpdateClicked} = action;
      return {
        ...state,
        saveAndUpdateClicked,
      };
    case SET_OPEN_SECTION_INDEX:
      const {openSectionIndex} = action;
      return {
        ...state,
        openSectionIndex,
      };
    case UPDATE_LISTING_DATA:
      return {
        ...state,
        fieldsToRevise: {},
        fieldsToDelete: {},
        listingData: action.listingData,
      };
    case UPDATE_CATEGORY_SITE_DATA:
      return {
        ...state,
        categorySiteData: action.categorySiteData,
      };
    case UPDATE_SELLER_POLICIES:
      return {
        ...state,
        sellerPolicies: action.sellerPolicies,
      };
    case UPDATE_MULTIPLE_FIELDS_TO_REVISE:
      let newState = state;
      _.forEach(action.payload, updateFieldAction => {
        newState = updateFieldToReviseFunc(newState, updateFieldAction);
      });
      return newState;
    case UPDATE_FIELD_TO_REVISE:
      return updateFieldToReviseFunc(state, action);
    case RESET_FIELDS_TO_REVISE:
      return update(state, {
        fieldsToRevise: {$set: {}},
        fieldsToDelete: {$set: {}},
        blurredFields: {$set: {}},
        saveAndUpdateClicked: {$set: false},
      });
    case UPDATE_FIELD_TO_DELETE:
      const {fields} = action;
      let {fieldsToRevise} = state;
      fieldsToDelete = {...fieldsToDelete, ...(_.isString(fields) ? {[fields]: 1} : _.mapValues(fields, () => 1))};
      fieldsToRevise = _.omit(fieldsToRevise, _.isString(fields) ? fields : _.keys(fields));
      return update(state, {
        fieldsToDelete: {$set: fieldsToDelete},
        fieldsToRevise: {$set: fieldsToRevise},
      });
    case UPDATE_RECENTLY_USED_CATEGORIES:
      const {recentlyUsedCategories} = action;
      return update(state, {
        recentlyUsedCategories: {$set: recentlyUsedCategories},
      });
    case UPDATE_BLURRED_FIELD:
      return update(state, {
        blurredFields: {
          [action.fieldName]: {
            $set: true,
          },
        },
      });
    case UPDATE_SNACKBAR_PROPS:
      return update(state, {
        snackbarProps: {$apply: snackbarProps => ({...snackbarProps, ...action.snackbarProps})},
      });
    case SET_PRODUCT_DATA:
      return update(state, {
        productData: {$set: action.productData},
      });
    case SET_OPEN_CATEGORY_SELECTOR:
      return update(state, {
        openCategorySelector: {$set: action.open},
      });
    default:
      return state;
  }
}

export const updateListingData = makeActionCreator(UPDATE_LISTING_DATA, 'listingData');
export const updateSellerPolicies = makeActionCreator(UPDATE_SELLER_POLICIES, 'sellerPolicies');
export const updateCategorySiteData = makeActionCreator(UPDATE_CATEGORY_SITE_DATA, 'categorySiteData');
export const updateFieldToRevise = makeActionCreator(
  UPDATE_FIELD_TO_REVISE,
  'fieldNames',
  'fieldValue',
  'fieldProps',
  'originalValue'
);
export const updateMultipleFieldsToRevise = createStandardAction(UPDATE_MULTIPLE_FIELDS_TO_REVISE)<
  updateMultipleFieldsToReviseAction[]
>();
export const updateFieldToDelete = makeActionCreator(UPDATE_FIELD_TO_DELETE, 'fields');
export const resetFieldsToRevise = makeActionCreator(RESET_FIELDS_TO_REVISE);
export const clearStore = makeActionCreator(CLEAR_STORE);
export const updateRecentlyUsedCategories = makeActionCreator(
  UPDATE_RECENTLY_USED_CATEGORIES,
  'recentlyUsedCategories'
);
export const setSaveAndUpdateClicked = makeActionCreator(SET_SAVE_AND_UPDATE_CLICKED, 'saveAndUpdateClicked');
export const setOpenSectionIndex = makeActionCreator(SET_OPEN_SECTION_INDEX, 'openSectionIndex');
export const updateBlurredField = makeActionCreator(UPDATE_BLURRED_FIELD, 'fieldName');
export const updateSnackbarProps = makeActionCreator(UPDATE_SNACKBAR_PROPS, 'snackbarProps');
export const setProductData = makeActionCreator(SET_PRODUCT_DATA, 'productData');
export const setOpenCategorySelector = makeActionCreator(SET_OPEN_CATEGORY_SELECTOR, 'open');
